




















import { PropType } from 'vue';

import { ConfigurationItem } from '@/models/configurator/configuration';

import mixins from '@/utils/mixins';
import functions from '@/mixins/functions';
import Proxyable from '@/mixins/proxyable';

export default mixins(functions, Proxyable).extend({
  props: { item: Object as PropType<ConfigurationItem> },

  data: () => ({
    quantityErrors: [] as string[],
    quantityLoading: false
  }),

  methods: {
    debounceQuantity(quantity: number) {
      this.quantityLoading = true;
      this.debounce(this.updateQuantity, 250)(quantity || 0);
    },

    updateQuantity(quantity: number) {
      this.quantityLoading = false;

      // TODO: LF-2021-03-27 - Quantity Textfield should not know zero means delete item
      // This should be generic and just give feedback that quantity changed
      // We should have a generic DebounceQuantityTextField
      const signal = quantity > 0 ? 'update:quantity' : 'delete:item';
      this.$emit(signal, this.item);
    }
  }
});
